import React from "react";
import useStore from "../store/store";
import { styled } from "@mui/material/styles";
import { checkIP } from "../hooks/PublicIP";

export default function Seat({ seatIndex, user }) {
  const [getSeated, getSeat, setSeat, office] = useStore((state) => [
    state.getSeated,
    state.getSeat,
    state.setSeat,
    state.office,
  ]);
  const seat = getSeat(seatIndex);
  if (!seat) return;

  const bgColor = seat.name ? "#ebfcff" : seat.free ? "#fffbe5" : "#f1f3f4";
  const cursor = seat.free || seat.owner === user ? "pointer" : "auto";

  const handleClick = async (event) => {
    if (!checkIP(office)) return;

    // if (seat.free) {
    //   if (user === seat.name) {
    //     setSeat(seatIndex, "");
    //   } else if (!getSeated(user)) {
    //     setSeat(seatIndex, user);
    //   }
    // } else if (user === seat.name) {
    //   setSeat(seatIndex, user);
    // }
    // if (seat.free || seat.owner === user) {
    //   if (user === seat.name) {
    //     setSeat(seatIndex, "");
    //   } else if (!getSeated(user)) {
    //     setSeat(seatIndex, user);
    //   }
    // }
    console.log('user: ', user)
    console.log('seat: ', seat)
    if (user === seat.name) {
      setSeat(seatIndex, "");
    } else if (!seat.name && (seat.free || seat.owner === user)) {
      const seated = await getSeated(user, seat.seat_id)
      console.log('seated: ', seated)
      if (!seated.user && !seated.seat) {
        setSeat(seatIndex, user);
      }
      else {
        alert("Please refresh and select seat again.")
      }
    }

    // else if (user === seat.name) {
    //   setSeat(seatIndex, user);
    // }
  };

  return (
    <SeatMain
      style={{
        cursor: cursor,
        background: bgColor,
      }}
      onClick={handleClick}
    >
      {/* <SeatNo>{seatIndex + 1}</SeatNo> */}
      <SeatNo>{seat.seat_id}</SeatNo>
      <SeatName>
        {"name" in seat && seat.name ? seat.name : seat.owner}
      </SeatName>
    </SeatMain>
  );
}

const SeatMain = styled("div")({
  width: "90px",
  minWidth: "90px",
  height: "90px",
  border: "1px solid #cacdd1",
  borderRadius: "5px",
  margin: "0px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "0.7rem",
  position: "relative",
});

const SeatNo = styled("div")({
  position: "absolute",
  top: "2px",
  left: "4px",
  fontSize: "0.6rem",
});

const SeatName = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
});
